const unsplashed = "https://source.unsplash.com/200x200/";

const photos = [
  {
    id:1,
    name: "Evangeline",
    designation: "Web Developer",
    heading: "Career Changer",
    msg: `Leaving my desk job without prior IT experience, I embarked on M-Squared's comprehensive web development course. This training not only equipped me with the necessary skills but also instilled confidence. I am now enthusiastic about my promising career trajectory in the tech industry, thanks to this transformative training program.`,
  },
  {
    id:2,
    name: "Abey",
    designation: "Software Engineer",
    heading: "Skill Booster",
    msg: `As an experienced IT professional, I needed to stay ahead of the curve. M-Squared's web development course provided me with the latest tools and techniques to strengthen my skills and advance my career.`,
  },
  {
    id:3,
    name: "Antony Ouseph",
    designation: "Web Developer",
    heading: "Internship Success",
    msg: `My career kick-started from the training program in M-Squared under the guidance of Jisha Hari and Sajith S. The course was well structured and delivered in a very effective manner which helped me learn a lot in a very short time`,
  },
  {
    id:4,
    name: "Sini J",
    designation: "Web Developer",
    heading: "Career Changer",
    msg: `I had an exceptional experience at one of the best Software Development centers in Trivandrum and Kochi. I gained extensive knowledge and thoroughly enjoyed the class, learning a great deal. I highly recommend this center to anyone seeking exposure to software training.`,
  },
  {
    id:5,
    name: "Sobin Anna Joseph",
    designation: "Software Engineer",
    heading: "Skill Booster",
    msg: `The software internship program was very good and useful in my career growth. As a newbie, after this course, I gained the confidence that I can excel beyond what I felt was possible.`,
  },
  {
    id:6,
    name: "Govt Polytechnic College, Neyyattinkara",
    designation: "Internship",
    heading: "Professional Pivoter",
    msg: "We had a great experience in our 3 weeks Internship with M Squared Software Services Pvt Ltd, in Technopark Campus. Acquired a lot of information and also we really enjoyed the class and learned a great deal. We would definitely recommend M Squared to others who want to get exposure through internship.",
  },
];

export default photos;
